import { Injectable } from '@angular/core';
import { BehaviorSubject, map, Subject, Subscription, tap, timer } from 'rxjs';
import { SharedService } from './shared.service';
import { ApiResponce } from '../interfaces/apiResponce.interface';
import { Order } from '../interfaces/order.interface';
import { GlobalLoaderService } from './global-loader.service';
import { KitcheOrder } from '../interfaces/kitchen-orders';
import { TrigerToastService } from './triger-toast.service';
import { RestaurantUser } from '../interfaces/loginUserRes.interface';

@Injectable({
  providedIn: 'root',
})
export class AutoReloadService {
  public filteredOrdersSubject = new BehaviorSubject<Order[]>([]);
  public filteredOrders$ = this.filteredOrdersSubject.asObservable();
  public pendingOrderNotifySubject = new BehaviorSubject<any>([]);
  public pendingOrderNotifySubject$ = this.filteredOrdersSubject.asObservable();

  public todaysKitcheOrderSubject = new BehaviorSubject<any>([]);
  public filterOrderFlag = new BehaviorSubject<any>(0);
  subscribe!: Subscription;
  subscribeKitchen!: Subscription;
public loading:boolean=false
  constructor(
    private sharedS: SharedService,
    private globabLoaderS: GlobalLoaderService,
    private toastS: TrigerToastService
  ) {}

  subscribeTheCounter() {
    const source = timer(1000, 3000); // Starts after 1 sec, repeats every 3 sec
    this.subscribe = source.subscribe((count) => {
      this.getPendingOrderApi();
    });
  }
  
  public addOrderToFilteredData(newOrder: Order) {
    let currentOrders = this.filteredOrdersSubject.getValue();
    currentOrders = [...currentOrders, newOrder].sort((a, b) => b.dailyorder_id - a.dailyorder_id);   
    this.filteredOrdersSubject.next(currentOrders);
  }
  
  
  getPendingOrderApi(autoRefresh:boolean=true,refresh:boolean=false) {
if(!autoRefresh){
  this.loading=true
  this.globabLoaderS.triggerLoader(true)
}else if(refresh){
  this.loading=true
}
      this.sharedS.sendGetRequest('get_today_orders_of_restaurant_branch').pipe(
          tap(() => this.globabLoaderS.triggerLoader(false)),
          map((res: ApiResponce) => {
            if (!res.Success) {
              throw new Error(res.Message);
            }
            return res.Data || [];
          })
        ).subscribe({
          next: (orders: Order[]) => {
            if (orders.length === 0) {
              this.pendingOrderNotifySubject.next([]);
              // this.TableLoader = false;
              this.loading = false;
              this.globabLoaderS.triggerLoader(false);
              return;
            }  
            let pendingOrders: Order[] = [];
            let processedOrders: Order[] = [];
            for (const order of orders) {
              if (order.status_id === 1) {
                pendingOrders.push(order);
              } else {
                processedOrders.push(order);
              }
            } 
            this.pendingOrderNotifySubject.next(pendingOrders);
            this.filteredOrdersSubject.next(processedOrders);
            // this.TableLoader = false;
            this.loading=false;
            this.globabLoaderS.triggerLoader(false);
    
          },
          error: (err: any) => {
            console.error('Error:', err);
            this.globabLoaderS.triggerLoader(false);
            // this.TableLoader = false;
            this.loading=false
            this.toastS.showToast({
              Message: err.message || 'An error occurred!',
              shortMessage: 'Error!',
              type: 'error',
            });
          }
        });
  }

  getTodayKitchenOrders() {
    this.todaysKitcheOrderSubject.next([]);
    this.globabLoaderS.triggerLoader(true);
    this.subscribeKitchen = this.sharedS
      .sendGetRequest('get_today_orders_of_kitchen')
      .subscribe({
        next: (res: ApiResponce) => {
          if (res.Success) {
            this.globabLoaderS.triggerLoader(false);
            if (res.Data.length === 0) return;
            if (res.Data.length > 0) {
              this.todaysKitcheOrderSubject.next(res.Data);
            }
          } else {
            this.globabLoaderS.triggerLoader(false);
          }
        },
        error: (err: any) => {
          console.error('Error:', err);
        },
      });
  }

  unSubscribeCounter() {
    if (this.subscribe) {
      this.subscribe.unsubscribe();
      this.pendingOrderNotifySubject.next([])
      console.log("Un-Sub... Counter");
    }else{
      console.log("Counter is not Subscribed");
    }
  }

  unSubscribeKitchenOrders() {
    if (this.subscribeKitchen) {
      this.subscribeKitchen.unsubscribe();
    }
  }
}
